import {
    GET_DAYWISE_DELIVERYMAN_UNIQUE_SHOPS_REPORT,
} from '../../../../Types'

const DayWiseDeliverymanUniqueShopsReportReducer = (state = [], action) => {
    switch (action.type) {
        case GET_DAYWISE_DELIVERYMAN_UNIQUE_SHOPS_REPORT:
            return action.payload
        default:
            return state
    }
}
export default DayWiseDeliverymanUniqueShopsReportReducer
